"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnekFinder = void 0;
var React = _interopRequireWildcard(require("react"));
var _Finder = _interopRequireDefault(require("./components/organisms/Finder"));
var _ImageViewer = _interopRequireDefault(require("./components/organisms/ImageViewer"));
var _SnekFinderProvider = require("./SnekFinderProvider");
var _SnekStudio = _interopRequireDefault(require("./components/molecules/SnekStudio"));
var _react2 = require("@chakra-ui/react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useSnekFinder = ({
  mode,
  ...props
}) => {
  const {
    backend,
    initData,
    rootFileId
  } = (0, _SnekFinderProvider.useSnekFinderContext)();
  const [isSelectorOpen, setIsSelectorOpen] = React.useState(false);
  const [data, setData] = React.useState(initData);
  React.useEffect(() => {
    setData(initData);
  }, [initData]);
  React.useEffect(() => {
    const fn = async () => {
      const index = await backend.readIndex();

      // check if data is different from index

      const newData = index || initData;
      const isDataDifferent = JSON.stringify(newData) !== JSON.stringify(data);
      if (isDataDifferent) {
        setData(newData);
      }
    };
    fn();
  }, [isSelectorOpen]);
  const [openFile, setOpenFile] = React.useState(null);
  const openedFileItem = React.useMemo(() => {
    if (!openFile || !openFile.fileId) {
      return null;
    }
    const {
      fileId
    } = openFile;
    const item = data[fileId];
    if (!item) {
      return null;
    } else if (item.isFolder) {
      return null;
    }
    return item;
  }, [openFile, data]);
  const handleDataChange = React.useCallback(async newData => {
    await backend.writeIndex(newData);
    setData(newData);
  }, [backend]);
  const handleFileOpen = React.useCallback(fileId => {
    const file = data[fileId];
    if (!file.isFolder) {
      const {
        mimeType
      } = file;
      if (mimeType && mimeType.startsWith('image/')) {
        setOpenFile({
          fileId,
          previewType: 'IMAGE_VIEWER'
        });
      } else if (mimeType && mimeType.startsWith('application/pdf')) {
        setOpenFile({
          fileId,
          previewType: 'PDF_VIEWER'
        });
      }
    }
  }, [data, setOpenFile]);
  const toggleSnekStudio = React.useCallback((src, name) => {
    setOpenFile(null);
    setIsSelectorOpen(false);
    setOpenFile({
      fileId: '',
      previewType: 'SNEK_STUDIO',
      src,
      name
    });
  }, [setOpenFile, isSelectorOpen, setIsSelectorOpen]);
  const handleFinderClose = React.useCallback(() => {
    setOpenFile(null);
    setIsSelectorOpen(false);
  }, [setOpenFile, isSelectorOpen, setIsSelectorOpen]);
  const toggleSelector = React.useCallback(() => {
    setIsSelectorOpen(!isSelectorOpen);
  }, [isSelectorOpen, setIsSelectorOpen]);
  const toggleSelectorPreview = React.useCallback(fileId => {
    toggleSelector();
    handleFileOpen(fileId);
  }, [toggleSelector]);
  const toggleSelectorSelect = React.useCallback((_, file) => {
    props.onSelect && props.onSelect(file);
    toggleSelector();
  }, [toggleSelector]);
  console.log(openFile);
  const finderElement = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [openFile && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [openedFileItem && openFile.previewType === 'IMAGE_VIEWER' && openFile.fileId && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageViewer.default, {
        src: openedFileItem.src,
        name: openedFileItem.name,
        onUpdate: async (blob, {
          fullName,
          imageBase64,
          extension,
          mimeType
        }) => {
          const fileId = openFile.fileId;
          setData(data => {
            if (fullName) {
              return {
                ...data,
                [fileId]: {
                  ...data[fileId],
                  src: imageBase64,
                  name: fullName
                }
              };
            } else {
              return {
                ...data,
                [fileId]: {
                  ...data[fileId],
                  src: imageBase64
                }
              };
            }
          });

          // upload blob to backend
          if (blob) {
            const uploaded = await backend.upload(new File([blob], openedFileItem.name, {
              type: mimeType
            }));
            setData(data => {
              const newData = {
                ...data,
                [fileId]: {
                  ...data[fileId],
                  src: uploaded.src,
                  previewSrc: uploaded.previewSrc
                }
              };
              backend.writeIndex(newData);
              return newData;
            });
          }
        },
        onClose: () => setOpenFile(null)
      }), openFile.previewType === 'SNEK_STUDIO' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react2.Modal, {
        isOpen: true,
        onClose: () => setOpenFile(null),
        size: "6xl",
        isCentered: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.ModalOverlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.ModalContent, {
          h: "85vh",
          overflow: 'hidden',
          p: "4",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SnekStudio.default, {
            isOpen: true,
            src: openFile.src,
            name: openFile.name,
            shouldClose: () => setOpenFile(null),
            onComplete: async (blob, editedImageObject) => {
              if (!blob) {
                throw new Error('blob is required');
              }
              const file = new File([blob], editedImageObject.fullName || editedImageObject.name, {
                type: editedImageObject.mimeType
              });
              const uploaded = await backend.upload(file);
              props.onSnekStudioUpdate && props.onSnekStudioUpdate(file, uploaded.src, editedImageObject);
              setOpenFile(null);
            }
          })
        })]
      })]
    }), !(mode === 'selector' && !isSelectorOpen) && mode !== 'editor' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Finder.default, {
      data: data,
      mode: mode,
      rootUUID: rootFileId,
      onItemOpen: handleFileOpen,
      onDataChanged: handleDataChange,
      onSelectorClose: handleFinderClose,
      onSelectorSelect: toggleSelectorSelect,
      onUploadFile: backend.upload
    })]
  });
  return {
    finderElement,
    toggleSelector,
    toggleSelectorPreview,
    toggleSnekStudio
  };
};
exports.useSnekFinder = useSnekFinder;